import { io } from 'socket.io-client';

// const URL = "http://localhost:3010";
const URL = "https://city2city.kretosstechnology.com";
// const URL = "https://city2city-dev.kretosstechnology.com";

export const socket = io(URL, {
  autoConnect: false,
});
